import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { VehicleModelPage } from './vehicle-model.page';

const routes: Routes = [
  {
    path: '',
    component: VehicleModelPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VehicleModelePageRoutingModule {}
